import React from 'react';
import ReactExport from 'react-data-export';
import { intlShape, injectIntl } from 'react-intl';

import Fab from '@material-ui/core/Fab';
import { DownloadIcon } from '../../../../images/icons/WrapSvg';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Download extends React.Component {
    render() {
        const { intl, info, parameters } = this.props;
        return (
            <ExcelFile
                element={
                    <Fab
                        color="primary"
                        aria-label="add"
                        className={'button_float'}
                        onClick={this.handleClick}
                    >
                        <DownloadIcon />
                    </Fab>
                }
            >
                <ExcelSheet data={parameters} name={intl.formatMessage({ id: 'parameters' })}>
                    <ExcelColumn label={intl.formatMessage({ id: 'field' })} value="type" />
                    <ExcelColumn label={intl.formatMessage({ id: 'value' })} value="value" />
                    <ExcelColumn label={intl.formatMessage({ id: 'local' })} value="local" />
                    <ExcelColumn
                        label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                        value="from"
                    />
                    <ExcelColumn
                        label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                        value="to"
                    />
                </ExcelSheet>
                <ExcelSheet data={info} name={intl.formatMessage({ id: 'report_search_values' })}>
                    <ExcelColumn label={intl.formatMessage({ id: 'instance' })} value="id" />
                    <ExcelColumn label={intl.formatMessage({ id: 'date' })} value="fecha" />
                    <ExcelColumn label={intl.formatMessage({ id: 'local' })} value="local" />
                    <ExcelColumn label={intl.formatMessage({ id: 'value' })} value="valor" />
                </ExcelSheet>
            </ExcelFile>
        );
    }
}
Download.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Download);



// WEBPACK FOOTER //
// ./src/components/complex/reports/lot/Download.js